/******************************************************************************
 * This file was generated by langium-cli 4.1.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/
/* eslint-disable */
import * as langium from 'langium';
export const PypestreamPifTerminals = {
    WHITESPACE: /\s+/,
    AUDIO_STRING: /(?:(?<!\\)")audio(?:(?<!\\)")/,
    BUTTON_STRING: /(?:(?<!\\)")button(?:(?<!\\)")/,
    BUTTONS_STRING: /(?:(?<!\\)")buttons(?:(?<!\\)")/,
    CAROUSEL_STRING: /(?:(?<!\\)")carousel(?:(?<!\\)")/,
    DATE_PICKER_STRING: /(?:(?<!\\)")datepicker(?:(?<!\\)")/,
    DEEP_LINK_STRING: /(?:(?<!\\)")deeplink(?:(?<!\\)")/,
    DOCUMENT_STRING: /(?:(?<!\\)")document(?:(?<!\\)")/,
    FILE_UPLOAD_STRING: /(?:(?<!\\)")file_upload(?:(?<!\\)")/,
    IMAGE_BUTTON_STRING: /(?:(?<!\\)")imagebutton(?:(?<!\\)")/,
    IMAGE_STRING: /(?:(?<!\\)")image(?:(?<!\\)")/,
    LIST_PICKER_STRING: /(?:(?<!\\)")listpicker(?:(?<!\\)")/,
    LOCATION_STRING: /(?:(?<!\\)")location(?:(?<!\\)")/,
    NONE_STRING: /(?:(?<!\\)")none(?:(?<!\\)")/,
    PERSISTENT_MENU_STRING: /(?:(?<!\\)")persistent_menu(?:(?<!\\)")/,
    PNG_STRING: /(?:(?<!\\)")png(?:(?<!\\)")/,
    QUICK_REPLY_STRING: /(?:(?<!\\)")quick_reply(?:(?<!\\)")/,
    SECURE_STRING: /(?:(?<!\\)")secure(?:(?<!\\)")/,
    SELECTION_STRING: /(?:(?<!\\)")selection(?:(?<!\\)")/,
    STAR_STRING: /(?:(?<!\\)")star(?:(?<!\\)")/,
    TIME_PICKER_STRING: /(?:(?<!\\)")timepicker(?:(?<!\\)")/,
    VIDEO_STRING: /(?:(?<!\\)")video(?:(?<!\\)")/,
    WEB_VIEW_STRING: /(?:(?<!\\)")webview(?:(?<!\\)")/,
    NODE_NUMBER_STRING: /(?:(?<!\\)")nodeNumber(?:(?<!\\)")/,
    NODE_TYPE_STRING: /(?:(?<!\\)")nodeType(?:(?<!\\)")/,
    NODE_NAME_STRING: /(?:(?<!\\)")nodeName(?:(?<!\\)")/,
    NEXT_NODES_STRING: /(?:(?<!\\)")nextNodes(?:(?<!\\)")/,
    MESSAGE_STRING: /(?:(?<!\\)")message(?:(?<!\\)")/,
    ANSWER_REQUIRED_STRING: /(?:(?<!\\)")answerRequired(?:(?<!\\)")/,
    BEHAVIORS_STRING: /(?:(?<!\\)")behaviors(?:(?<!\\)")/,
    COMMAND_STRING: /(?:(?<!\\)")command(?:(?<!\\)")/,
    DESCRIPTION_STRING: /(?:(?<!\\)")description(?:(?<!\\)")/,
    OUTPUT_STRING: /(?:(?<!\\)")output(?:(?<!\\)")/,
    NODE_INPUT_STRING: /(?:(?<!\\)")nodeInput(?:(?<!\\)")/,
    PARAMETER_INPUT_STRING: /(?:(?<!\\)")parameterInput(?:(?<!\\)")/,
    DECISION_VARIABLE_STRING: /(?:(?<!\\)")decisionVariable(?:(?<!\\)")/,
    WHATS_NEXT_STRING: /(?:(?<!\\)")whatsNext(?:(?<!\\)")/,
    INTENT_STRING: /(?:(?<!\\)")intent(?:(?<!\\)")/,
    NLU_DISABLED_STRING: /(?:(?<!\\)")nluDisabled(?:(?<!\\)")/,
    NODE_TAGS_STRING: /(?:(?<!\\)")nodeTags(?:(?<!\\)")/,
    SKILL_TAG_STRING: /(?:(?<!\\)")skillTag(?:(?<!\\)")/,
    VARIABLES_STRING: /(?:(?<!\\)")variables(?:(?<!\\)")/,
    PLATFORM_FLAG_STRING: /(?:(?<!\\)")platformFlag(?:(?<!\\)")/,
    UTTERANCES_STRING: /(?:(?<!\\)")utterances(?:(?<!\\)")/,
    FLOWS_STRING: /(?:(?<!\\)")flows(?:(?<!\\)")/,
    CSS_CLASS_NAME_STRING: /(?:(?<!\\)")cssClassName(?:(?<!\\)")/,
    GROUP_NAME_STRING: /(?:(?<!\\)")groupName(?:(?<!\\)")/,
    GROUP_ORDER_STRING: /(?:(?<!\\)")groupOrder(?:(?<!\\)")/,
    ID_STRING: /(?:(?<!\\)")id(?:(?<!\\)")/,
    EVENT_STRING: /(?:(?<!\\)")event(?:(?<!\\)")/,
    RICH_ASSET_STRING: /(?:(?<!\\)")richAsset(?:(?<!\\)")/,
    TYPE_STRING: /(?:(?<!\\)")type(?:(?<!\\)")/,
    ALT_TEXT_STRING: /(?:(?<!\\)")alt_text(?:(?<!\\)")/,
    DEST_STRING: /(?:(?<!\\)")dest(?:(?<!\\)")/,
    STATIC_STRING: /(?:(?<!\\)")static(?:(?<!\\)")/,
    DYNAMIC_STRING: /(?:(?<!\\)")dynamic(?:(?<!\\)")/,
    LABEL_STRING: /(?:(?<!\\)")label(?:(?<!\\)")/,
    URL_STRING: /(?:(?<!\\)")url(?:(?<!\\)")/,
    LOOP_STRING: /(?:(?<!\\)")loop(?:(?<!\\)")/,
    SOURCE_NODE_STRING: /(?:(?<!\\)")source_node(?:(?<!\\)")/,
    SOURCE_VAR_STRING: /(?:(?<!\\)")source_var(?:(?<!\\)")/,
    CONTENT_STRING: /(?:(?<!\\)")content(?:(?<!\\)")/,
    SEND_STRING: /(?:(?<!\\)")send(?:(?<!\\)")/,
    EVENT_NAME_STRING: /(?:(?<!\\)")event_name(?:(?<!\\)")/,
    HIDE_USER_TEXT_STRING: /(?:(?<!\\)")hide-user-text(?:(?<!\\)")/,
    HIDE_APP_TEXT_STRING: /(?:(?<!\\)")hide-app-text(?:(?<!\\)")/,
    ADDITIONAL_PROPERTIES_STRING: /(?:(?<!\\)")additional_properties(?:(?<!\\)")/,
    GLOBAL_PROPERTIES_STRING: /(?:(?<!\\)")global_props(?:(?<!\\)")/,
    GLOBAL_PROPS_UNSET_STRING: /(?:(?<!\\)")global_props_unset(?:(?<!\\)")/,
    RETENTION_DAYS_STRING: /(?:(?<!\\)")retention_days(?:(?<!\\)")/,
    OPTIONS_STRING: /(?:(?<!\\)")options(?:(?<!\\)")/,
    ICON_PREFIX_STRING: /(?:(?<!\\)")icon_prefix(?:(?<!\\)")/,
    ICON_SUFFIX_STRING: /(?:(?<!\\)")icon_suffix(?:(?<!\\)")/,
    VARS_STRING: /(?:(?<!\\)")vars(?:(?<!\\)")/,
    VARIABLE_STRING: /(?:(?<!\\)")variable(?:(?<!\\)")/,
    VALUE_STRING: /(?:(?<!\\)")value(?:(?<!\\)")/,
    TITLE_STRING: /(?:(?<!\\)")title(?:(?<!\\)")/,
    SUBTITLE_STRING: /(?:(?<!\\)")subtitle(?:(?<!\\)")/,
    OPT_TEXT_STRING: /(?:(?<!\\)")opt_text(?:(?<!\\)")/,
    ADDITIONAL_CTA_STRING: /(?:(?<!\\)")additional_cta(?:(?<!\\)")/,
    IOS_URL_STRING: /(?:(?<!\\)")ios_url(?:(?<!\\)")/,
    ANDROID_URL_STRING: /(?:(?<!\\)")android_url(?:(?<!\\)")/,
    IOS_STORE_STRING: /(?:(?<!\\)")ios_store(?:(?<!\\)")/,
    ANDROID_STORE_STRING: /(?:(?<!\\)")android_store(?:(?<!\\)")/,
    UPLOAD_LABEL_STRING: /(?:(?<!\\)")upload_label(?:(?<!\\)")/,
    CANCEL_LABEL_STRING: /(?:(?<!\\)")cancel_label(?:(?<!\\)")/,
    ENDPOINT_STRING: /(?:(?<!\\)")endpoint(?:(?<!\\)")/,
    ACTION_SCRIPT_STRING: /(?:(?<!\\)")action_script(?:(?<!\\)")/,
    HEADERS_STRING: /(?:(?<!\\)")headers(?:(?<!\\)")/,
    SET_VALUE_STRING: /(?:(?<!\\)")set_value(?:(?<!\\)")/,
    CTA_LABEL_STRING: /(?:(?<!\\)")cta_label(?:(?<!\\)")/,
    INLINE_STRING: /(?:(?<!\\)")inline(?:(?<!\\)")/,
    CLOSE_MESSAGE_STRING: /(?:(?<!\\)")close_message(?:(?<!\\)")/,
    EMPTY_STRING: /(?:(?<!\\)")\s*(?:(?<!\\)")/,
    COMMA: /,/,
    QUOTE: /(?<!\\)"/,
    OPEN_CURLY_BRACKET: /(?<!"){/,
    CLOSE_CURLY_BRACKET: /}/,
    OPEN_SQUARE_BRACKET: /(?<!")\[/,
    CLOSE_SQUARE_BRACKET: /\]/,
    COLON: /:/,
    DECIMALS: /(?<!")[-]?(\d+\.\d+|\.\d+)/,
    INTEGERS: /(?<!")[-]?\d+(?![a-zA-Z_-])/,
    BOOLEAN: /(?<!")(true|false)(?![a-zA-Z_-])/i,
    NULL: /(?<!")null/,
    UNQUOTED_STRING: /(?:(?<=\\)"|[^"])+/,
};
export const ActionScriptProperty = {
    $type: 'ActionScriptProperty',
    actionScript: 'actionScript'
};
export function isActionScriptProperty(item) {
    return reflection.isInstance(item, ActionScriptProperty.$type);
}
export const AdditionalCtaArrayProperty = {
    $type: 'AdditionalCtaArrayProperty',
    items: 'items'
};
export function isAdditionalCtaArrayProperty(item) {
    return reflection.isInstance(item, AdditionalCtaArrayProperty.$type);
}
export const AdditionalCtaItem = {
    $type: 'AdditionalCtaItem',
    properties: 'properties'
};
export function isAdditionalCtaItem(item) {
    return reflection.isInstance(item, AdditionalCtaItem.$type);
}
export const AdditionalPropertiesProperty = {
    $type: 'AdditionalPropertiesProperty',
    additionalProperties: 'additionalProperties'
};
export function isAdditionalPropertiesProperty(item) {
    return reflection.isInstance(item, AdditionalPropertiesProperty.$type);
}
export const AltTextProperty = {
    $type: 'AltTextProperty',
    altText: 'altText'
};
export function isAltTextProperty(item) {
    return reflection.isInstance(item, AltTextProperty.$type);
}
export const AndroidStoreProperty = {
    $type: 'AndroidStoreProperty',
    androidStore: 'androidStore'
};
export function isAndroidStoreProperty(item) {
    return reflection.isInstance(item, AndroidStoreProperty.$type);
}
export const AndroidUrlProperty = {
    $type: 'AndroidUrlProperty',
    androidUrl: 'androidUrl'
};
export function isAndroidUrlProperty(item) {
    return reflection.isInstance(item, AndroidUrlProperty.$type);
}
export const AnswerRequired = {
    $type: 'AnswerRequired',
    answerRequired: 'answerRequired'
};
export function isAnswerRequired(item) {
    return reflection.isInstance(item, AnswerRequired.$type);
}
export const AudioJson = {
    $type: 'AudioJson',
    properties: 'properties'
};
export function isAudioJson(item) {
    return reflection.isInstance(item, AudioJson.$type);
}
export const Behaviors = {
    $type: 'Behaviors',
    behaviors: 'behaviors'
};
export function isBehaviors(item) {
    return reflection.isInstance(item, Behaviors.$type);
}
export const BooleanField = {
    $type: 'BooleanField',
    value: 'value'
};
export function isBooleanField(item) {
    return reflection.isInstance(item, BooleanField.$type);
}
export const ButtonOption = {
    $type: 'ButtonOption',
    properties: 'properties'
};
export function isButtonOption(item) {
    return reflection.isInstance(item, ButtonOption.$type);
}
export const ButtonOptionsArrayProperty = {
    $type: 'ButtonOptionsArrayProperty',
    options: 'options'
};
export function isButtonOptionsArrayProperty(item) {
    return reflection.isInstance(item, ButtonOptionsArrayProperty.$type);
}
export const ButtonsJson = {
    $type: 'ButtonsJson',
    properties: 'properties'
};
export function isButtonsJson(item) {
    return reflection.isInstance(item, ButtonsJson.$type);
}
export const CancelLabelProperty = {
    $type: 'CancelLabelProperty',
    cancelLabel: 'cancelLabel'
};
export function isCancelLabelProperty(item) {
    return reflection.isInstance(item, CancelLabelProperty.$type);
}
export const CarouselItem = {
    $type: 'CarouselItem',
    properties: 'properties'
};
export function isCarouselItem(item) {
    return reflection.isInstance(item, CarouselItem.$type);
}
export const CarouselJson = {
    $type: 'CarouselJson',
    items: 'items'
};
export function isCarouselJson(item) {
    return reflection.isInstance(item, CarouselJson.$type);
}
export const CloseMessageProperty = {
    $type: 'CloseMessageProperty',
    closeMessage: 'closeMessage'
};
export function isCloseMessageProperty(item) {
    return reflection.isInstance(item, CloseMessageProperty.$type);
}
export const Command = {
    $type: 'Command',
    command: 'command'
};
export function isCommand(item) {
    return reflection.isInstance(item, Command.$type);
}
export const CssClassName = {
    $type: 'CssClassName',
    cssClassName: 'cssClassName'
};
export function isCssClassName(item) {
    return reflection.isInstance(item, CssClassName.$type);
}
export const CtaLabelProperty = {
    $type: 'CtaLabelProperty',
    ctaLabel: 'ctaLabel'
};
export function isCtaLabelProperty(item) {
    return reflection.isInstance(item, CtaLabelProperty.$type);
}
export const DatePickerJson = {
    $type: 'DatePickerJson',
    properties: 'properties'
};
export function isDatePickerJson(item) {
    return reflection.isInstance(item, DatePickerJson.$type);
}
export const DecisionVariable = {
    $type: 'DecisionVariable',
    decisionVariable: 'decisionVariable'
};
export function isDecisionVariable(item) {
    return reflection.isInstance(item, DecisionVariable.$type);
}
export const DeepLinkJson = {
    $type: 'DeepLinkJson',
    properties: 'properties'
};
export function isDeepLinkJson(item) {
    return reflection.isInstance(item, DeepLinkJson.$type);
}
export const Description = {
    $type: 'Description',
    description: 'description'
};
export function isDescription(item) {
    return reflection.isInstance(item, Description.$type);
}
export const DescriptionProperty = {
    $type: 'DescriptionProperty',
    description: 'description'
};
export function isDescriptionProperty(item) {
    return reflection.isInstance(item, DescriptionProperty.$type);
}
export const DestProperty = {
    $type: 'DestProperty',
    dest: 'dest'
};
export function isDestProperty(item) {
    return reflection.isInstance(item, DestProperty.$type);
}
export const DocumentJson = {
    $type: 'DocumentJson',
    properties: 'properties'
};
export function isDocumentJson(item) {
    return reflection.isInstance(item, DocumentJson.$type);
}
export const DynamicEmbedJson = {
    $type: 'DynamicEmbedJson',
    properties: 'properties'
};
export function isDynamicEmbedJson(item) {
    return reflection.isInstance(item, DynamicEmbedJson.$type);
}
export const EmptyField = {
    $type: 'EmptyField',
    value: 'value'
};
export function isEmptyField(item) {
    return reflection.isInstance(item, EmptyField.$type);
}
export const EndpointProperty = {
    $type: 'EndpointProperty',
    endpoint: 'endpoint'
};
export function isEndpointProperty(item) {
    return reflection.isInstance(item, EndpointProperty.$type);
}
export const Event = {
    $type: 'Event',
    event: 'event'
};
export function isEvent(item) {
    return reflection.isInstance(item, Event.$type);
}
export const EventNameProperty = {
    $type: 'EventNameProperty',
    eventName: 'eventName'
};
export function isEventNameProperty(item) {
    return reflection.isInstance(item, EventNameProperty.$type);
}
export const EventObject = {
    $type: 'EventObject',
    properties: 'properties'
};
export function isEventObject(item) {
    return reflection.isInstance(item, EventObject.$type);
}
export const Field = {
    $type: 'Field',
    value: 'value'
};
export function isField(item) {
    return reflection.isInstance(item, Field.$type);
}
export const FileUploadJson = {
    $type: 'FileUploadJson',
    properties: 'properties'
};
export function isFileUploadJson(item) {
    return reflection.isInstance(item, FileUploadJson.$type);
}
export const FileUploadTypeProperty = {
    $type: 'FileUploadTypeProperty',
    type: 'type'
};
export function isFileUploadTypeProperty(item) {
    return reflection.isInstance(item, FileUploadTypeProperty.$type);
}
export const Flows = {
    $type: 'Flows',
    flows: 'flows'
};
export function isFlows(item) {
    return reflection.isInstance(item, Flows.$type);
}
export const GenericJsonArray = {
    $type: 'GenericJsonArray',
    values: 'values'
};
export function isGenericJsonArray(item) {
    return reflection.isInstance(item, GenericJsonArray.$type);
}
export const GenericJsonMember = {
    $type: 'GenericJsonMember',
    key: 'key',
    value: 'value'
};
export function isGenericJsonMember(item) {
    return reflection.isInstance(item, GenericJsonMember.$type);
}
export const GenericJsonObject = {
    $type: 'GenericJsonObject',
    members: 'members'
};
export function isGenericJsonObject(item) {
    return reflection.isInstance(item, GenericJsonObject.$type);
}
export const GlobalPropertiesProperty = {
    $type: 'GlobalPropertiesProperty',
    globalProperties: 'globalProperties'
};
export function isGlobalPropertiesProperty(item) {
    return reflection.isInstance(item, GlobalPropertiesProperty.$type);
}
export const GlobalPropsUnsetProperty = {
    $type: 'GlobalPropsUnsetProperty',
    globalPropsUnset: 'globalPropsUnset'
};
export function isGlobalPropsUnsetProperty(item) {
    return reflection.isInstance(item, GlobalPropsUnsetProperty.$type);
}
export const GroupName = {
    $type: 'GroupName',
    groupName: 'groupName'
};
export function isGroupName(item) {
    return reflection.isInstance(item, GroupName.$type);
}
export const GroupOrder = {
    $type: 'GroupOrder',
    groupOrder: 'groupOrder'
};
export function isGroupOrder(item) {
    return reflection.isInstance(item, GroupOrder.$type);
}
export const HeaderProperty = {
    $type: 'HeaderProperty',
    key: 'key',
    value: 'value'
};
export function isHeaderProperty(item) {
    return reflection.isInstance(item, HeaderProperty.$type);
}
export const HeadersProperty = {
    $type: 'HeadersProperty',
    headers: 'headers'
};
export function isHeadersProperty(item) {
    return reflection.isInstance(item, HeadersProperty.$type);
}
export const HideAppTextProperty = {
    $type: 'HideAppTextProperty',
    hide: 'hide'
};
export function isHideAppTextProperty(item) {
    return reflection.isInstance(item, HideAppTextProperty.$type);
}
export const HideUserTextProperty = {
    $type: 'HideUserTextProperty',
    hide: 'hide'
};
export function isHideUserTextProperty(item) {
    return reflection.isInstance(item, HideUserTextProperty.$type);
}
export const IconPrefixProperty = {
    $type: 'IconPrefixProperty',
    iconPrefix: 'iconPrefix'
};
export function isIconPrefixProperty(item) {
    return reflection.isInstance(item, IconPrefixProperty.$type);
}
export const IconSuffixProperty = {
    $type: 'IconSuffixProperty',
    iconSuffix: 'iconSuffix'
};
export function isIconSuffixProperty(item) {
    return reflection.isInstance(item, IconSuffixProperty.$type);
}
export const Id = {
    $type: 'Id',
    id: 'id'
};
export function isId(item) {
    return reflection.isInstance(item, Id.$type);
}
export const ImageButtonJson = {
    $type: 'ImageButtonJson',
    properties: 'properties'
};
export function isImageButtonJson(item) {
    return reflection.isInstance(item, ImageButtonJson.$type);
}
export const ImageButtonOption = {
    $type: 'ImageButtonOption',
    properties: 'properties'
};
export function isImageButtonOption(item) {
    return reflection.isInstance(item, ImageButtonOption.$type);
}
export const ImageButtonOptionsArrayProperty = {
    $type: 'ImageButtonOptionsArrayProperty',
    options: 'options'
};
export function isImageButtonOptionsArrayProperty(item) {
    return reflection.isInstance(item, ImageButtonOptionsArrayProperty.$type);
}
export const ImageJson = {
    $type: 'ImageJson',
    properties: 'properties'
};
export function isImageJson(item) {
    return reflection.isInstance(item, ImageJson.$type);
}
export const ImageProperty = {
    $type: 'ImageProperty',
    image: 'image'
};
export function isImageProperty(item) {
    return reflection.isInstance(item, ImageProperty.$type);
}
export const InlineProperty = {
    $type: 'InlineProperty',
    inline: 'inline'
};
export function isInlineProperty(item) {
    return reflection.isInstance(item, InlineProperty.$type);
}
export const Intent = {
    $type: 'Intent',
    intent: 'intent'
};
export function isIntent(item) {
    return reflection.isInstance(item, Intent.$type);
}
export const IosStoreProperty = {
    $type: 'IosStoreProperty',
    iosStore: 'iosStore'
};
export function isIosStoreProperty(item) {
    return reflection.isInstance(item, IosStoreProperty.$type);
}
export const IosUrlProperty = {
    $type: 'IosUrlProperty',
    iosUrl: 'iosUrl'
};
export function isIosUrlProperty(item) {
    return reflection.isInstance(item, IosUrlProperty.$type);
}
export const LabelProperty = {
    $type: 'LabelProperty',
    label: 'label'
};
export function isLabelProperty(item) {
    return reflection.isInstance(item, LabelProperty.$type);
}
export const ListPickerJson = {
    $type: 'ListPickerJson',
    properties: 'properties'
};
export function isListPickerJson(item) {
    return reflection.isInstance(item, ListPickerJson.$type);
}
export const ListPickerOption = {
    $type: 'ListPickerOption',
    properties: 'properties'
};
export function isListPickerOption(item) {
    return reflection.isInstance(item, ListPickerOption.$type);
}
export const ListPickerOptionsArrayProperty = {
    $type: 'ListPickerOptionsArrayProperty',
    options: 'options'
};
export function isListPickerOptionsArrayProperty(item) {
    return reflection.isInstance(item, ListPickerOptionsArrayProperty.$type);
}
export const LocationJson = {
    $type: 'LocationJson',
    properties: 'properties'
};
export function isLocationJson(item) {
    return reflection.isInstance(item, LocationJson.$type);
}
export const LoopProperty = {
    $type: 'LoopProperty',
    loop: 'loop'
};
export function isLoopProperty(item) {
    return reflection.isInstance(item, LoopProperty.$type);
}
export const Message = {
    $type: 'Message',
    message: 'message'
};
export function isMessage(item) {
    return reflection.isInstance(item, Message.$type);
}
export const MessageProperty = {
    $type: 'MessageProperty',
    message: 'message'
};
export function isMessageProperty(item) {
    return reflection.isInstance(item, MessageProperty.$type);
}
export const NextNodes = {
    $type: 'NextNodes',
    nextNodes: 'nextNodes'
};
export function isNextNodes(item) {
    return reflection.isInstance(item, NextNodes.$type);
}
export const NluDisabled = {
    $type: 'NluDisabled',
    nluDisabled: 'nluDisabled'
};
export function isNluDisabled(item) {
    return reflection.isInstance(item, NluDisabled.$type);
}
export const Node = {
    $type: 'Node',
    fields: 'fields',
    name: 'name'
};
export function isNode(item) {
    return reflection.isInstance(item, Node.$type);
}
export const NodeInputs = {
    $type: 'NodeInputs',
    nodeInput: 'nodeInput'
};
export function isNodeInputs(item) {
    return reflection.isInstance(item, NodeInputs.$type);
}
export const NodeName = {
    $type: 'NodeName',
    nodeName: 'nodeName'
};
export function isNodeName(item) {
    return reflection.isInstance(item, NodeName.$type);
}
export const NodeTags = {
    $type: 'NodeTags',
    nodeTags: 'nodeTags'
};
export function isNodeTags(item) {
    return reflection.isInstance(item, NodeTags.$type);
}
export const NodeType = {
    $type: 'NodeType',
    nodeType: 'nodeType'
};
export function isNodeType(item) {
    return reflection.isInstance(item, NodeType.$type);
}
export const NumbersField = {
    $type: 'NumbersField',
    value: 'value'
};
export function isNumbersField(item) {
    return reflection.isInstance(item, NumbersField.$type);
}
export const OptTextProperty = {
    $type: 'OptTextProperty',
    optText: 'optText'
};
export function isOptTextProperty(item) {
    return reflection.isInstance(item, OptTextProperty.$type);
}
export const Output = {
    $type: 'Output',
    output: 'output'
};
export function isOutput(item) {
    return reflection.isInstance(item, Output.$type);
}
export const ParameterInput = {
    $type: 'ParameterInput',
    parameterInput: 'parameterInput'
};
export function isParameterInput(item) {
    return reflection.isInstance(item, ParameterInput.$type);
}
export const PersistentMenuJson = {
    $type: 'PersistentMenuJson',
    properties: 'properties'
};
export function isPersistentMenuJson(item) {
    return reflection.isInstance(item, PersistentMenuJson.$type);
}
export const PersistentMenuOption = {
    $type: 'PersistentMenuOption',
    properties: 'properties'
};
export function isPersistentMenuOption(item) {
    return reflection.isInstance(item, PersistentMenuOption.$type);
}
export const PersistentMenuOptionsArrayProperty = {
    $type: 'PersistentMenuOptionsArrayProperty',
    options: 'options'
};
export function isPersistentMenuOptionsArrayProperty(item) {
    return reflection.isInstance(item, PersistentMenuOptionsArrayProperty.$type);
}
export const PifFile = {
    $type: 'PifFile',
    nodes: 'nodes',
    translations: 'translations'
};
export function isPifFile(item) {
    return reflection.isInstance(item, PifFile.$type);
}
export const PlatformFlag = {
    $type: 'PlatformFlag',
    platformFlag: 'platformFlag'
};
export function isPlatformFlag(item) {
    return reflection.isInstance(item, PlatformFlag.$type);
}
export const QuickReplyJson = {
    $type: 'QuickReplyJson',
    properties: 'properties'
};
export function isQuickReplyJson(item) {
    return reflection.isInstance(item, QuickReplyJson.$type);
}
export const QuickReplyOption = {
    $type: 'QuickReplyOption',
    properties: 'properties'
};
export function isQuickReplyOption(item) {
    return reflection.isInstance(item, QuickReplyOption.$type);
}
export const QuickReplyOptionsArrayProperty = {
    $type: 'QuickReplyOptionsArrayProperty',
    options: 'options'
};
export function isQuickReplyOptionsArrayProperty(item) {
    return reflection.isInstance(item, QuickReplyOptionsArrayProperty.$type);
}
export const RetentionDaysProperty = {
    $type: 'RetentionDaysProperty',
    retentionDays: 'retentionDays'
};
export function isRetentionDaysProperty(item) {
    return reflection.isInstance(item, RetentionDaysProperty.$type);
}
export const RichAsset = {
    $type: 'RichAsset',
    content: 'content'
};
export function isRichAsset(item) {
    return reflection.isInstance(item, RichAsset.$type);
}
export const RichAssetAudio = {
    $type: 'RichAssetAudio',
    type: 'type',
    value: 'value'
};
export function isRichAssetAudio(item) {
    return reflection.isInstance(item, RichAssetAudio.$type);
}
export const RichAssetButton = {
    $type: 'RichAssetButton',
    type: 'type',
    value: 'value'
};
export function isRichAssetButton(item) {
    return reflection.isInstance(item, RichAssetButton.$type);
}
export const RichAssetButtons = {
    $type: 'RichAssetButtons',
    type: 'type',
    value: 'value'
};
export function isRichAssetButtons(item) {
    return reflection.isInstance(item, RichAssetButtons.$type);
}
export const RichAssetCarousel = {
    $type: 'RichAssetCarousel',
    type: 'type',
    value: 'value'
};
export function isRichAssetCarousel(item) {
    return reflection.isInstance(item, RichAssetCarousel.$type);
}
export const RichAssetDatePicker = {
    $type: 'RichAssetDatePicker',
    type: 'type',
    value: 'value'
};
export function isRichAssetDatePicker(item) {
    return reflection.isInstance(item, RichAssetDatePicker.$type);
}
export const RichAssetDeepLink = {
    $type: 'RichAssetDeepLink',
    type: 'type',
    value: 'value'
};
export function isRichAssetDeepLink(item) {
    return reflection.isInstance(item, RichAssetDeepLink.$type);
}
export const RichAssetDocument = {
    $type: 'RichAssetDocument',
    type: 'type',
    value: 'value'
};
export function isRichAssetDocument(item) {
    return reflection.isInstance(item, RichAssetDocument.$type);
}
export const RichAssetFileUpload = {
    $type: 'RichAssetFileUpload',
    type: 'type',
    value: 'value'
};
export function isRichAssetFileUpload(item) {
    return reflection.isInstance(item, RichAssetFileUpload.$type);
}
export const RichAssetImage = {
    $type: 'RichAssetImage',
    type: 'type',
    value: 'value'
};
export function isRichAssetImage(item) {
    return reflection.isInstance(item, RichAssetImage.$type);
}
export const RichAssetImageButton = {
    $type: 'RichAssetImageButton',
    type: 'type',
    value: 'value'
};
export function isRichAssetImageButton(item) {
    return reflection.isInstance(item, RichAssetImageButton.$type);
}
export const RichAssetListPicker = {
    $type: 'RichAssetListPicker',
    type: 'type',
    value: 'value'
};
export function isRichAssetListPicker(item) {
    return reflection.isInstance(item, RichAssetListPicker.$type);
}
export const RichAssetLocation = {
    $type: 'RichAssetLocation',
    type: 'type',
    value: 'value'
};
export function isRichAssetLocation(item) {
    return reflection.isInstance(item, RichAssetLocation.$type);
}
export const RichAssetNone = {
    $type: 'RichAssetNone',
    type: 'type',
    value: 'value'
};
export function isRichAssetNone(item) {
    return reflection.isInstance(item, RichAssetNone.$type);
}
export const RichAssetPersistentMenu = {
    $type: 'RichAssetPersistentMenu',
    type: 'type',
    value: 'value'
};
export function isRichAssetPersistentMenu(item) {
    return reflection.isInstance(item, RichAssetPersistentMenu.$type);
}
export const RichAssetPng = {
    $type: 'RichAssetPng',
    type: 'type',
    value: 'value'
};
export function isRichAssetPng(item) {
    return reflection.isInstance(item, RichAssetPng.$type);
}
export const RichAssetQuickReply = {
    $type: 'RichAssetQuickReply',
    type: 'type',
    value: 'value'
};
export function isRichAssetQuickReply(item) {
    return reflection.isInstance(item, RichAssetQuickReply.$type);
}
export const RichAssetSecure = {
    $type: 'RichAssetSecure',
    type: 'type',
    value: 'value'
};
export function isRichAssetSecure(item) {
    return reflection.isInstance(item, RichAssetSecure.$type);
}
export const RichAssetSelection = {
    $type: 'RichAssetSelection',
    type: 'type',
    value: 'value'
};
export function isRichAssetSelection(item) {
    return reflection.isInstance(item, RichAssetSelection.$type);
}
export const RichAssetStar = {
    $type: 'RichAssetStar',
    type: 'type',
    value: 'value'
};
export function isRichAssetStar(item) {
    return reflection.isInstance(item, RichAssetStar.$type);
}
export const RichAssetTimePicker = {
    $type: 'RichAssetTimePicker',
    type: 'type',
    value: 'value'
};
export function isRichAssetTimePicker(item) {
    return reflection.isInstance(item, RichAssetTimePicker.$type);
}
export const RichAssetUnknown = {
    $type: 'RichAssetUnknown',
    type: 'type',
    value: 'value'
};
export function isRichAssetUnknown(item) {
    return reflection.isInstance(item, RichAssetUnknown.$type);
}
export const RichAssetVideo = {
    $type: 'RichAssetVideo',
    type: 'type',
    value: 'value'
};
export function isRichAssetVideo(item) {
    return reflection.isInstance(item, RichAssetVideo.$type);
}
export const RichAssetWebView = {
    $type: 'RichAssetWebView',
    type: 'type',
    value: 'value'
};
export function isRichAssetWebView(item) {
    return reflection.isInstance(item, RichAssetWebView.$type);
}
export const SecureJson = {
    $type: 'SecureJson',
    properties: 'properties'
};
export function isSecureJson(item) {
    return reflection.isInstance(item, SecureJson.$type);
}
export const SendProperty = {
    $type: 'SendProperty',
    send: 'send'
};
export function isSendProperty(item) {
    return reflection.isInstance(item, SendProperty.$type);
}
export const SetValueProperty = {
    $type: 'SetValueProperty',
    setValue: 'setValue'
};
export function isSetValueProperty(item) {
    return reflection.isInstance(item, SetValueProperty.$type);
}
export const SkillTag = {
    $type: 'SkillTag',
    skillTag: 'skillTag'
};
export function isSkillTag(item) {
    return reflection.isInstance(item, SkillTag.$type);
}
export const SourceNodeProperty = {
    $type: 'SourceNodeProperty',
    sourceNode: 'sourceNode'
};
export function isSourceNodeProperty(item) {
    return reflection.isInstance(item, SourceNodeProperty.$type);
}
export const SourceVariableProperty = {
    $type: 'SourceVariableProperty',
    sourceVar: 'sourceVar'
};
export function isSourceVariableProperty(item) {
    return reflection.isInstance(item, SourceVariableProperty.$type);
}
export const StarJson = {
    $type: 'StarJson',
    properties: 'properties'
};
export function isStarJson(item) {
    return reflection.isInstance(item, StarJson.$type);
}
export const StarOption = {
    $type: 'StarOption',
    destProperty: 'destProperty'
};
export function isStarOption(item) {
    return reflection.isInstance(item, StarOption.$type);
}
export const StarOptionsArrayProperty = {
    $type: 'StarOptionsArrayProperty',
    options: 'options'
};
export function isStarOptionsArrayProperty(item) {
    return reflection.isInstance(item, StarOptionsArrayProperty.$type);
}
export const StringField = {
    $type: 'StringField',
    value: 'value'
};
export function isStringField(item) {
    return reflection.isInstance(item, StringField.$type);
}
export const SubTitleProperty = {
    $type: 'SubTitleProperty',
    subTitle: 'subTitle'
};
export function isSubTitleProperty(item) {
    return reflection.isInstance(item, SubTitleProperty.$type);
}
export const TimePickerJson = {
    $type: 'TimePickerJson',
    properties: 'properties'
};
export function isTimePickerJson(item) {
    return reflection.isInstance(item, TimePickerJson.$type);
}
export const TitleProperty = {
    $type: 'TitleProperty',
    title: 'title'
};
export function isTitleProperty(item) {
    return reflection.isInstance(item, TitleProperty.$type);
}
export const Translation = {
    $type: 'Translation'
};
export function isTranslation(item) {
    return reflection.isInstance(item, Translation.$type);
}
export const TypeDynamicProperty = {
    $type: 'TypeDynamicProperty',
    value: 'value'
};
export function isTypeDynamicProperty(item) {
    return reflection.isInstance(item, TypeDynamicProperty.$type);
}
export const TypeStaticProperty = {
    $type: 'TypeStaticProperty',
    value: 'value'
};
export function isTypeStaticProperty(item) {
    return reflection.isInstance(item, TypeStaticProperty.$type);
}
export const UploadLabelProperty = {
    $type: 'UploadLabelProperty',
    uploadLabel: 'uploadLabel'
};
export function isUploadLabelProperty(item) {
    return reflection.isInstance(item, UploadLabelProperty.$type);
}
export const UrlProperty = {
    $type: 'UrlProperty',
    url: 'url'
};
export function isUrlProperty(item) {
    return reflection.isInstance(item, UrlProperty.$type);
}
export const UrlsProperty = {
    $type: 'UrlsProperty',
    urls: 'urls'
};
export function isUrlsProperty(item) {
    return reflection.isInstance(item, UrlsProperty.$type);
}
export const Utterances = {
    $type: 'Utterances',
    utterances: 'utterances'
};
export function isUtterances(item) {
    return reflection.isInstance(item, Utterances.$type);
}
export const ValueProperty = {
    $type: 'ValueProperty',
    value: 'value'
};
export function isValueProperty(item) {
    return reflection.isInstance(item, ValueProperty.$type);
}
export const VariableObject = {
    $type: 'VariableObject',
    properties: 'properties'
};
export function isVariableObject(item) {
    return reflection.isInstance(item, VariableObject.$type);
}
export const VariableProperty = {
    $type: 'VariableProperty',
    variable: 'variable'
};
export function isVariableProperty(item) {
    return reflection.isInstance(item, VariableProperty.$type);
}
export const Variables = {
    $type: 'Variables',
    variables: 'variables'
};
export function isVariables(item) {
    return reflection.isInstance(item, Variables.$type);
}
export const VariablesArrayProperty = {
    $type: 'VariablesArrayProperty',
    variables: 'variables'
};
export function isVariablesArrayProperty(item) {
    return reflection.isInstance(item, VariablesArrayProperty.$type);
}
export const VariablesProperty = {
    $type: 'VariablesProperty',
    variables: 'variables'
};
export function isVariablesProperty(item) {
    return reflection.isInstance(item, VariablesProperty.$type);
}
export const VideoJson = {
    $type: 'VideoJson',
    properties: 'properties'
};
export function isVideoJson(item) {
    return reflection.isInstance(item, VideoJson.$type);
}
export const WebViewJson = {
    $type: 'WebViewJson',
    properties: 'properties'
};
export function isWebViewJson(item) {
    return reflection.isInstance(item, WebViewJson.$type);
}
export const WhatsNext = {
    $type: 'WhatsNext',
    whatsNext: 'whatsNext'
};
export function isWhatsNext(item) {
    return reflection.isInstance(item, WhatsNext.$type);
}
export class PypestreamPifAstReflection extends langium.AbstractAstReflection {
    constructor() {
        super(...arguments);
        this.types = {
            ActionScriptProperty: {
                name: ActionScriptProperty.$type,
                properties: {
                    actionScript: {
                        name: ActionScriptProperty.actionScript
                    }
                },
                superTypes: []
            },
            AdditionalCtaArrayProperty: {
                name: AdditionalCtaArrayProperty.$type,
                properties: {
                    items: {
                        name: AdditionalCtaArrayProperty.items,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            AdditionalCtaItem: {
                name: AdditionalCtaItem.$type,
                properties: {
                    properties: {
                        name: AdditionalCtaItem.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            AdditionalPropertiesProperty: {
                name: AdditionalPropertiesProperty.$type,
                properties: {
                    additionalProperties: {
                        name: AdditionalPropertiesProperty.additionalProperties
                    }
                },
                superTypes: []
            },
            AltTextProperty: {
                name: AltTextProperty.$type,
                properties: {
                    altText: {
                        name: AltTextProperty.altText
                    }
                },
                superTypes: []
            },
            AndroidStoreProperty: {
                name: AndroidStoreProperty.$type,
                properties: {
                    androidStore: {
                        name: AndroidStoreProperty.androidStore
                    }
                },
                superTypes: []
            },
            AndroidUrlProperty: {
                name: AndroidUrlProperty.$type,
                properties: {
                    androidUrl: {
                        name: AndroidUrlProperty.androidUrl
                    }
                },
                superTypes: []
            },
            AnswerRequired: {
                name: AnswerRequired.$type,
                properties: {
                    answerRequired: {
                        name: AnswerRequired.answerRequired
                    }
                },
                superTypes: []
            },
            AudioJson: {
                name: AudioJson.$type,
                properties: {
                    properties: {
                        name: AudioJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            Behaviors: {
                name: Behaviors.$type,
                properties: {
                    behaviors: {
                        name: Behaviors.behaviors,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            BooleanField: {
                name: BooleanField.$type,
                properties: {
                    value: {
                        name: BooleanField.value
                    }
                },
                superTypes: []
            },
            ButtonOption: {
                name: ButtonOption.$type,
                properties: {
                    properties: {
                        name: ButtonOption.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ButtonOptionsArrayProperty: {
                name: ButtonOptionsArrayProperty.$type,
                properties: {
                    options: {
                        name: ButtonOptionsArrayProperty.options,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ButtonsJson: {
                name: ButtonsJson.$type,
                properties: {
                    properties: {
                        name: ButtonsJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            CancelLabelProperty: {
                name: CancelLabelProperty.$type,
                properties: {
                    cancelLabel: {
                        name: CancelLabelProperty.cancelLabel
                    }
                },
                superTypes: []
            },
            CarouselItem: {
                name: CarouselItem.$type,
                properties: {
                    properties: {
                        name: CarouselItem.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            CarouselJson: {
                name: CarouselJson.$type,
                properties: {
                    items: {
                        name: CarouselJson.items,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            CloseMessageProperty: {
                name: CloseMessageProperty.$type,
                properties: {
                    closeMessage: {
                        name: CloseMessageProperty.closeMessage
                    }
                },
                superTypes: []
            },
            Command: {
                name: Command.$type,
                properties: {
                    command: {
                        name: Command.command
                    }
                },
                superTypes: []
            },
            CssClassName: {
                name: CssClassName.$type,
                properties: {
                    cssClassName: {
                        name: CssClassName.cssClassName
                    }
                },
                superTypes: []
            },
            CtaLabelProperty: {
                name: CtaLabelProperty.$type,
                properties: {
                    ctaLabel: {
                        name: CtaLabelProperty.ctaLabel
                    }
                },
                superTypes: []
            },
            DatePickerJson: {
                name: DatePickerJson.$type,
                properties: {
                    properties: {
                        name: DatePickerJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            DecisionVariable: {
                name: DecisionVariable.$type,
                properties: {
                    decisionVariable: {
                        name: DecisionVariable.decisionVariable
                    }
                },
                superTypes: []
            },
            DeepLinkJson: {
                name: DeepLinkJson.$type,
                properties: {
                    properties: {
                        name: DeepLinkJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            Description: {
                name: Description.$type,
                properties: {
                    description: {
                        name: Description.description
                    }
                },
                superTypes: []
            },
            DescriptionProperty: {
                name: DescriptionProperty.$type,
                properties: {
                    description: {
                        name: DescriptionProperty.description
                    }
                },
                superTypes: []
            },
            DestProperty: {
                name: DestProperty.$type,
                properties: {
                    dest: {
                        name: DestProperty.dest,
                        referenceType: Node.$type
                    }
                },
                superTypes: []
            },
            DocumentJson: {
                name: DocumentJson.$type,
                properties: {
                    properties: {
                        name: DocumentJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            DynamicEmbedJson: {
                name: DynamicEmbedJson.$type,
                properties: {
                    properties: {
                        name: DynamicEmbedJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            EmptyField: {
                name: EmptyField.$type,
                properties: {
                    value: {
                        name: EmptyField.value
                    }
                },
                superTypes: [Translation.$type]
            },
            EndpointProperty: {
                name: EndpointProperty.$type,
                properties: {
                    endpoint: {
                        name: EndpointProperty.endpoint
                    }
                },
                superTypes: []
            },
            Event: {
                name: Event.$type,
                properties: {
                    event: {
                        name: Event.event
                    }
                },
                superTypes: []
            },
            EventNameProperty: {
                name: EventNameProperty.$type,
                properties: {
                    eventName: {
                        name: EventNameProperty.eventName
                    }
                },
                superTypes: []
            },
            EventObject: {
                name: EventObject.$type,
                properties: {
                    properties: {
                        name: EventObject.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            Field: {
                name: Field.$type,
                properties: {
                    value: {
                        name: Field.value
                    }
                },
                superTypes: []
            },
            FileUploadJson: {
                name: FileUploadJson.$type,
                properties: {
                    properties: {
                        name: FileUploadJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            FileUploadTypeProperty: {
                name: FileUploadTypeProperty.$type,
                properties: {
                    type: {
                        name: FileUploadTypeProperty.type
                    }
                },
                superTypes: []
            },
            Flows: {
                name: Flows.$type,
                properties: {
                    flows: {
                        name: Flows.flows,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            GenericJsonArray: {
                name: GenericJsonArray.$type,
                properties: {
                    values: {
                        name: GenericJsonArray.values,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            GenericJsonMember: {
                name: GenericJsonMember.$type,
                properties: {
                    key: {
                        name: GenericJsonMember.key
                    },
                    value: {
                        name: GenericJsonMember.value
                    }
                },
                superTypes: []
            },
            GenericJsonObject: {
                name: GenericJsonObject.$type,
                properties: {
                    members: {
                        name: GenericJsonObject.members,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            GlobalPropertiesProperty: {
                name: GlobalPropertiesProperty.$type,
                properties: {
                    globalProperties: {
                        name: GlobalPropertiesProperty.globalProperties
                    }
                },
                superTypes: []
            },
            GlobalPropsUnsetProperty: {
                name: GlobalPropsUnsetProperty.$type,
                properties: {
                    globalPropsUnset: {
                        name: GlobalPropsUnsetProperty.globalPropsUnset,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            GroupName: {
                name: GroupName.$type,
                properties: {
                    groupName: {
                        name: GroupName.groupName
                    }
                },
                superTypes: []
            },
            GroupOrder: {
                name: GroupOrder.$type,
                properties: {
                    groupOrder: {
                        name: GroupOrder.groupOrder
                    }
                },
                superTypes: []
            },
            HeaderProperty: {
                name: HeaderProperty.$type,
                properties: {
                    key: {
                        name: HeaderProperty.key
                    },
                    value: {
                        name: HeaderProperty.value
                    }
                },
                superTypes: []
            },
            HeadersProperty: {
                name: HeadersProperty.$type,
                properties: {
                    headers: {
                        name: HeadersProperty.headers,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            HideAppTextProperty: {
                name: HideAppTextProperty.$type,
                properties: {
                    hide: {
                        name: HideAppTextProperty.hide
                    }
                },
                superTypes: []
            },
            HideUserTextProperty: {
                name: HideUserTextProperty.$type,
                properties: {
                    hide: {
                        name: HideUserTextProperty.hide
                    }
                },
                superTypes: []
            },
            IconPrefixProperty: {
                name: IconPrefixProperty.$type,
                properties: {
                    iconPrefix: {
                        name: IconPrefixProperty.iconPrefix
                    }
                },
                superTypes: []
            },
            IconSuffixProperty: {
                name: IconSuffixProperty.$type,
                properties: {
                    iconSuffix: {
                        name: IconSuffixProperty.iconSuffix
                    }
                },
                superTypes: []
            },
            Id: {
                name: Id.$type,
                properties: {
                    id: {
                        name: Id.id
                    }
                },
                superTypes: []
            },
            ImageButtonJson: {
                name: ImageButtonJson.$type,
                properties: {
                    properties: {
                        name: ImageButtonJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ImageButtonOption: {
                name: ImageButtonOption.$type,
                properties: {
                    properties: {
                        name: ImageButtonOption.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ImageButtonOptionsArrayProperty: {
                name: ImageButtonOptionsArrayProperty.$type,
                properties: {
                    options: {
                        name: ImageButtonOptionsArrayProperty.options,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ImageJson: {
                name: ImageJson.$type,
                properties: {
                    properties: {
                        name: ImageJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ImageProperty: {
                name: ImageProperty.$type,
                properties: {
                    image: {
                        name: ImageProperty.image
                    }
                },
                superTypes: []
            },
            InlineProperty: {
                name: InlineProperty.$type,
                properties: {
                    inline: {
                        name: InlineProperty.inline
                    }
                },
                superTypes: []
            },
            Intent: {
                name: Intent.$type,
                properties: {
                    intent: {
                        name: Intent.intent
                    }
                },
                superTypes: []
            },
            IosStoreProperty: {
                name: IosStoreProperty.$type,
                properties: {
                    iosStore: {
                        name: IosStoreProperty.iosStore
                    }
                },
                superTypes: []
            },
            IosUrlProperty: {
                name: IosUrlProperty.$type,
                properties: {
                    iosUrl: {
                        name: IosUrlProperty.iosUrl
                    }
                },
                superTypes: []
            },
            LabelProperty: {
                name: LabelProperty.$type,
                properties: {
                    label: {
                        name: LabelProperty.label
                    }
                },
                superTypes: []
            },
            ListPickerJson: {
                name: ListPickerJson.$type,
                properties: {
                    properties: {
                        name: ListPickerJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ListPickerOption: {
                name: ListPickerOption.$type,
                properties: {
                    properties: {
                        name: ListPickerOption.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ListPickerOptionsArrayProperty: {
                name: ListPickerOptionsArrayProperty.$type,
                properties: {
                    options: {
                        name: ListPickerOptionsArrayProperty.options,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            LocationJson: {
                name: LocationJson.$type,
                properties: {
                    properties: {
                        name: LocationJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            LoopProperty: {
                name: LoopProperty.$type,
                properties: {
                    loop: {
                        name: LoopProperty.loop
                    }
                },
                superTypes: []
            },
            Message: {
                name: Message.$type,
                properties: {
                    message: {
                        name: Message.message
                    }
                },
                superTypes: []
            },
            MessageProperty: {
                name: MessageProperty.$type,
                properties: {
                    message: {
                        name: MessageProperty.message
                    }
                },
                superTypes: []
            },
            NextNodes: {
                name: NextNodes.$type,
                properties: {
                    nextNodes: {
                        name: NextNodes.nextNodes,
                        defaultValue: [],
                        referenceType: Node.$type
                    }
                },
                superTypes: []
            },
            NluDisabled: {
                name: NluDisabled.$type,
                properties: {
                    nluDisabled: {
                        name: NluDisabled.nluDisabled
                    }
                },
                superTypes: []
            },
            Node: {
                name: Node.$type,
                properties: {
                    fields: {
                        name: Node.fields,
                        defaultValue: []
                    },
                    name: {
                        name: Node.name
                    }
                },
                superTypes: []
            },
            NodeInputs: {
                name: NodeInputs.$type,
                properties: {
                    nodeInput: {
                        name: NodeInputs.nodeInput
                    }
                },
                superTypes: []
            },
            NodeName: {
                name: NodeName.$type,
                properties: {
                    nodeName: {
                        name: NodeName.nodeName
                    }
                },
                superTypes: []
            },
            NodeTags: {
                name: NodeTags.$type,
                properties: {
                    nodeTags: {
                        name: NodeTags.nodeTags
                    }
                },
                superTypes: []
            },
            NodeType: {
                name: NodeType.$type,
                properties: {
                    nodeType: {
                        name: NodeType.nodeType
                    }
                },
                superTypes: []
            },
            NumbersField: {
                name: NumbersField.$type,
                properties: {
                    value: {
                        name: NumbersField.value
                    }
                },
                superTypes: []
            },
            OptTextProperty: {
                name: OptTextProperty.$type,
                properties: {
                    optText: {
                        name: OptTextProperty.optText
                    }
                },
                superTypes: []
            },
            Output: {
                name: Output.$type,
                properties: {
                    output: {
                        name: Output.output,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ParameterInput: {
                name: ParameterInput.$type,
                properties: {
                    parameterInput: {
                        name: ParameterInput.parameterInput
                    }
                },
                superTypes: []
            },
            PersistentMenuJson: {
                name: PersistentMenuJson.$type,
                properties: {
                    properties: {
                        name: PersistentMenuJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            PersistentMenuOption: {
                name: PersistentMenuOption.$type,
                properties: {
                    properties: {
                        name: PersistentMenuOption.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            PersistentMenuOptionsArrayProperty: {
                name: PersistentMenuOptionsArrayProperty.$type,
                properties: {
                    options: {
                        name: PersistentMenuOptionsArrayProperty.options,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            PifFile: {
                name: PifFile.$type,
                properties: {
                    nodes: {
                        name: PifFile.nodes,
                        defaultValue: []
                    },
                    translations: {
                        name: PifFile.translations,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            PlatformFlag: {
                name: PlatformFlag.$type,
                properties: {
                    platformFlag: {
                        name: PlatformFlag.platformFlag
                    }
                },
                superTypes: []
            },
            QuickReplyJson: {
                name: QuickReplyJson.$type,
                properties: {
                    properties: {
                        name: QuickReplyJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            QuickReplyOption: {
                name: QuickReplyOption.$type,
                properties: {
                    properties: {
                        name: QuickReplyOption.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            QuickReplyOptionsArrayProperty: {
                name: QuickReplyOptionsArrayProperty.$type,
                properties: {
                    options: {
                        name: QuickReplyOptionsArrayProperty.options,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            RetentionDaysProperty: {
                name: RetentionDaysProperty.$type,
                properties: {
                    retentionDays: {
                        name: RetentionDaysProperty.retentionDays
                    }
                },
                superTypes: []
            },
            RichAsset: {
                name: RichAsset.$type,
                properties: {
                    content: {
                        name: RichAsset.content
                    }
                },
                superTypes: []
            },
            RichAssetAudio: {
                name: RichAssetAudio.$type,
                properties: {
                    type: {
                        name: RichAssetAudio.type
                    },
                    value: {
                        name: RichAssetAudio.value
                    }
                },
                superTypes: []
            },
            RichAssetButton: {
                name: RichAssetButton.$type,
                properties: {
                    type: {
                        name: RichAssetButton.type
                    },
                    value: {
                        name: RichAssetButton.value
                    }
                },
                superTypes: []
            },
            RichAssetButtons: {
                name: RichAssetButtons.$type,
                properties: {
                    type: {
                        name: RichAssetButtons.type
                    },
                    value: {
                        name: RichAssetButtons.value
                    }
                },
                superTypes: []
            },
            RichAssetCarousel: {
                name: RichAssetCarousel.$type,
                properties: {
                    type: {
                        name: RichAssetCarousel.type
                    },
                    value: {
                        name: RichAssetCarousel.value
                    }
                },
                superTypes: []
            },
            RichAssetDatePicker: {
                name: RichAssetDatePicker.$type,
                properties: {
                    type: {
                        name: RichAssetDatePicker.type
                    },
                    value: {
                        name: RichAssetDatePicker.value
                    }
                },
                superTypes: []
            },
            RichAssetDeepLink: {
                name: RichAssetDeepLink.$type,
                properties: {
                    type: {
                        name: RichAssetDeepLink.type
                    },
                    value: {
                        name: RichAssetDeepLink.value
                    }
                },
                superTypes: []
            },
            RichAssetDocument: {
                name: RichAssetDocument.$type,
                properties: {
                    type: {
                        name: RichAssetDocument.type
                    },
                    value: {
                        name: RichAssetDocument.value
                    }
                },
                superTypes: []
            },
            RichAssetFileUpload: {
                name: RichAssetFileUpload.$type,
                properties: {
                    type: {
                        name: RichAssetFileUpload.type
                    },
                    value: {
                        name: RichAssetFileUpload.value
                    }
                },
                superTypes: []
            },
            RichAssetImage: {
                name: RichAssetImage.$type,
                properties: {
                    type: {
                        name: RichAssetImage.type
                    },
                    value: {
                        name: RichAssetImage.value
                    }
                },
                superTypes: []
            },
            RichAssetImageButton: {
                name: RichAssetImageButton.$type,
                properties: {
                    type: {
                        name: RichAssetImageButton.type
                    },
                    value: {
                        name: RichAssetImageButton.value
                    }
                },
                superTypes: []
            },
            RichAssetListPicker: {
                name: RichAssetListPicker.$type,
                properties: {
                    type: {
                        name: RichAssetListPicker.type
                    },
                    value: {
                        name: RichAssetListPicker.value
                    }
                },
                superTypes: []
            },
            RichAssetLocation: {
                name: RichAssetLocation.$type,
                properties: {
                    type: {
                        name: RichAssetLocation.type
                    },
                    value: {
                        name: RichAssetLocation.value
                    }
                },
                superTypes: []
            },
            RichAssetNone: {
                name: RichAssetNone.$type,
                properties: {
                    type: {
                        name: RichAssetNone.type
                    },
                    value: {
                        name: RichAssetNone.value
                    }
                },
                superTypes: []
            },
            RichAssetPersistentMenu: {
                name: RichAssetPersistentMenu.$type,
                properties: {
                    type: {
                        name: RichAssetPersistentMenu.type
                    },
                    value: {
                        name: RichAssetPersistentMenu.value
                    }
                },
                superTypes: []
            },
            RichAssetPng: {
                name: RichAssetPng.$type,
                properties: {
                    type: {
                        name: RichAssetPng.type
                    },
                    value: {
                        name: RichAssetPng.value
                    }
                },
                superTypes: []
            },
            RichAssetQuickReply: {
                name: RichAssetQuickReply.$type,
                properties: {
                    type: {
                        name: RichAssetQuickReply.type
                    },
                    value: {
                        name: RichAssetQuickReply.value
                    }
                },
                superTypes: []
            },
            RichAssetSecure: {
                name: RichAssetSecure.$type,
                properties: {
                    type: {
                        name: RichAssetSecure.type
                    },
                    value: {
                        name: RichAssetSecure.value
                    }
                },
                superTypes: []
            },
            RichAssetSelection: {
                name: RichAssetSelection.$type,
                properties: {
                    type: {
                        name: RichAssetSelection.type
                    },
                    value: {
                        name: RichAssetSelection.value
                    }
                },
                superTypes: []
            },
            RichAssetStar: {
                name: RichAssetStar.$type,
                properties: {
                    type: {
                        name: RichAssetStar.type
                    },
                    value: {
                        name: RichAssetStar.value
                    }
                },
                superTypes: []
            },
            RichAssetTimePicker: {
                name: RichAssetTimePicker.$type,
                properties: {
                    type: {
                        name: RichAssetTimePicker.type
                    },
                    value: {
                        name: RichAssetTimePicker.value
                    }
                },
                superTypes: []
            },
            RichAssetUnknown: {
                name: RichAssetUnknown.$type,
                properties: {
                    type: {
                        name: RichAssetUnknown.type
                    },
                    value: {
                        name: RichAssetUnknown.value
                    }
                },
                superTypes: []
            },
            RichAssetVideo: {
                name: RichAssetVideo.$type,
                properties: {
                    type: {
                        name: RichAssetVideo.type
                    },
                    value: {
                        name: RichAssetVideo.value
                    }
                },
                superTypes: []
            },
            RichAssetWebView: {
                name: RichAssetWebView.$type,
                properties: {
                    type: {
                        name: RichAssetWebView.type
                    },
                    value: {
                        name: RichAssetWebView.value
                    }
                },
                superTypes: []
            },
            SecureJson: {
                name: SecureJson.$type,
                properties: {
                    properties: {
                        name: SecureJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            SendProperty: {
                name: SendProperty.$type,
                properties: {
                    send: {
                        name: SendProperty.send
                    }
                },
                superTypes: []
            },
            SetValueProperty: {
                name: SetValueProperty.$type,
                properties: {
                    setValue: {
                        name: SetValueProperty.setValue
                    }
                },
                superTypes: []
            },
            SkillTag: {
                name: SkillTag.$type,
                properties: {
                    skillTag: {
                        name: SkillTag.skillTag
                    }
                },
                superTypes: []
            },
            SourceNodeProperty: {
                name: SourceNodeProperty.$type,
                properties: {
                    sourceNode: {
                        name: SourceNodeProperty.sourceNode,
                        referenceType: Node.$type
                    }
                },
                superTypes: []
            },
            SourceVariableProperty: {
                name: SourceVariableProperty.$type,
                properties: {
                    sourceVar: {
                        name: SourceVariableProperty.sourceVar
                    }
                },
                superTypes: []
            },
            StarJson: {
                name: StarJson.$type,
                properties: {
                    properties: {
                        name: StarJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            StarOption: {
                name: StarOption.$type,
                properties: {
                    destProperty: {
                        name: StarOption.destProperty
                    }
                },
                superTypes: []
            },
            StarOptionsArrayProperty: {
                name: StarOptionsArrayProperty.$type,
                properties: {
                    options: {
                        name: StarOptionsArrayProperty.options,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            StringField: {
                name: StringField.$type,
                properties: {
                    value: {
                        name: StringField.value
                    }
                },
                superTypes: []
            },
            SubTitleProperty: {
                name: SubTitleProperty.$type,
                properties: {
                    subTitle: {
                        name: SubTitleProperty.subTitle
                    }
                },
                superTypes: []
            },
            TimePickerJson: {
                name: TimePickerJson.$type,
                properties: {
                    properties: {
                        name: TimePickerJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            TitleProperty: {
                name: TitleProperty.$type,
                properties: {
                    title: {
                        name: TitleProperty.title
                    }
                },
                superTypes: []
            },
            Translation: {
                name: Translation.$type,
                properties: {},
                superTypes: []
            },
            TypeDynamicProperty: {
                name: TypeDynamicProperty.$type,
                properties: {
                    value: {
                        name: TypeDynamicProperty.value
                    }
                },
                superTypes: []
            },
            TypeStaticProperty: {
                name: TypeStaticProperty.$type,
                properties: {
                    value: {
                        name: TypeStaticProperty.value
                    }
                },
                superTypes: []
            },
            UploadLabelProperty: {
                name: UploadLabelProperty.$type,
                properties: {
                    uploadLabel: {
                        name: UploadLabelProperty.uploadLabel
                    }
                },
                superTypes: []
            },
            UrlProperty: {
                name: UrlProperty.$type,
                properties: {
                    url: {
                        name: UrlProperty.url
                    }
                },
                superTypes: []
            },
            UrlsProperty: {
                name: UrlsProperty.$type,
                properties: {
                    urls: {
                        name: UrlsProperty.urls
                    }
                },
                superTypes: []
            },
            Utterances: {
                name: Utterances.$type,
                properties: {
                    utterances: {
                        name: Utterances.utterances,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            ValueProperty: {
                name: ValueProperty.$type,
                properties: {
                    value: {
                        name: ValueProperty.value
                    }
                },
                superTypes: []
            },
            VariableObject: {
                name: VariableObject.$type,
                properties: {
                    properties: {
                        name: VariableObject.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            VariableProperty: {
                name: VariableProperty.$type,
                properties: {
                    variable: {
                        name: VariableProperty.variable
                    }
                },
                superTypes: []
            },
            Variables: {
                name: Variables.$type,
                properties: {
                    variables: {
                        name: Variables.variables,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            VariablesArrayProperty: {
                name: VariablesArrayProperty.$type,
                properties: {
                    variables: {
                        name: VariablesArrayProperty.variables,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            VariablesProperty: {
                name: VariablesProperty.$type,
                properties: {
                    variables: {
                        name: VariablesProperty.variables,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            VideoJson: {
                name: VideoJson.$type,
                properties: {
                    properties: {
                        name: VideoJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            WebViewJson: {
                name: WebViewJson.$type,
                properties: {
                    properties: {
                        name: WebViewJson.properties,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            WhatsNext: {
                name: WhatsNext.$type,
                properties: {
                    whatsNext: {
                        name: WhatsNext.whatsNext
                    }
                },
                superTypes: []
            }
        };
    }
}
export const reflection = new PypestreamPifAstReflection();
//# sourceMappingURL=ast.js.map